import {
    ADD_FAVOURITE_SURVEY,
    FETCH_ALL_SURVEY_SUCCESS,
    FILTER_SURVEY,
    GET_ALL_SURVEY,
    GET_UNSELECTED_ALL_SURVEY,
    HANDLE_SURVEY_REQUEST_CLOSE,
    HIDE_SURVEY_LOADER,
    SHOW_SURVEY_LOADER,
    ON_ADD_SURVEY,
    ON_ALL_SURVEY_SELECT,
    ON_SURVEY_CLOSE,
    ON_SURVEY_SELECT,
    ON_DELETE_SURVEY,
    ON_DELETE_SELECTED_SURVEY,
    ON_FILTER_SURVEY_OPTION_SELECT,
    ON_SAVE_SURVEY_SUCCESS,
    ON_TOGGLE_SURVEY_DRAWER,
    SHOW_SURVEY_MESSAGE,
    UPDATE_SEARCH_SURVEY,
    ON_SURVEY_QUESTIONS,
    CLEAR_SESSION,
} from 'constants/ActionTypes';

const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No surveys found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: 'All surveys',
    allSurvey: [],
    surveyList: [],
    selectedSurvey: null,
    selectedSurveys: 0,
    addSurveyState: false,
    searchSurvey: '',
    survey: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case ADD_FAVOURITE_SURVEY: {
            return {
                ...state,
                alertMessage: action.payload.starred ? 'Survey removed as star' : 'Survey marked as star',
                showMessage: true,
                surveyList: state.surveyList.map((survey) => survey.id === action.payload.id ? {
                    ...survey,
                    starred: !action.payload.starred
                } : survey),
                allSurvey: state.allSurvey.map((survey) => survey.id === action.payload.id ? {
                    ...survey,
                    starred: !action.payload.starred
                } : survey)
            };
        }
        case FETCH_ALL_SURVEY_SUCCESS: {
            return {
                ...state,
                loader: false,
                allSurvey: action.payload,
                surveyList: action.payload,
            };
        }
        case SHOW_SURVEY_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_SURVEY_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedSurveys = 0;
            const surveyList = state.surveyList.map(survey => {
                if (survey.selected) {
                    selectedSurveys++;
                }
                if (survey.id === action.payload.id) {
                    if (survey.selected) {
                        selectedSurveys++;
                    }
                    return action.payload;
                } else {
                    return survey;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedSurveys: selectedSurveys,
                surveyList: surveyList
            };
        }
        case ON_ADD_SURVEY: {
            return { ...state, addSurveyState: true };
        }
        case ON_SURVEY_CLOSE: {
            return { ...state, addSurveyState: false };
        }
        case ON_FILTER_SURVEY_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let surveyList = [];
            switch (action.payload.name) {
                case 'All surveys': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    surveyList = state.allSurvey;
                    break;
                }
                case 'Frequently accessed': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    surveyList = state.allSurvey.filter((survey) => survey.frequently);
                    break;
                }
                case 'Starred surveys': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    surveyList = state.allSurvey.filter((survey) => survey.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, surveyList, drawerState: false
            };
        }
        case ON_SAVE_SURVEY_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Survey Updated Successfully',
                showMessage: true,
                surveyList: action.payload,
                allSurvey: action.payload,
                loader: false,
            };
        }
        case ON_DELETE_SURVEY: {
            return {
                ...state,
                alertMessage: 'Survey Deleted Successfully',
                showMessage: true,
                allSurvey: state.allSurvey.filter((survey) => survey.id !== action.payload.id),
                surveyList: state.allSurvey.filter((survey) => survey.id !== action.payload.id),
            };
        }
        case ON_DELETE_SELECTED_SURVEY: {
            const surveys = state.allSurvey.filter((survey) => !survey.selected);
            return {
                ...state,
                alertMessage: 'Survey Deleted Successfully',
                showMessage: true,
                allSurvey: surveys,
                surveyList: surveys,
                selectedSurveys: 0
            };
        }
        case FILTER_SURVEY: {
            const { filterOption } = state;
            let surveyList = [];
            if (action.payload === '') {
                surveyList = state.allSurvey;
            } else {
                const filterSurvey = state.allSurvey.filter((survey) =>
                    survey.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === 'All surveys') {
                    surveyList = filterSurvey;
                } else if (filterOption === 'Frequently accessed') {
                    surveyList = filterSurvey.filter((survey) => survey.frequently);
                } else if (filterOption === 'Starred surveys') {
                    surveyList = filterSurvey.filter((survey) => survey.starred);
                }
            }
            return { ...state, surveyList: surveyList };
        }
        case GET_ALL_SURVEY: {
            let surveyList = state.allSurvey.map((survey) => survey ? {
                ...survey,
                selected: true
            } : survey);
            return {
                ...state,
                selectedSurveys: surveyList.length,
                allSurvey: surveyList,
                surveyList: surveyList
            };
        }
        case GET_UNSELECTED_ALL_SURVEY: {
            let surveyList = state.allSurvey.map((survey) => survey ? {
                ...survey,
                selected: false
            } : survey);
            return {
                ...state,
                selectedSurveys: 0,
                allSurvey: surveyList,
                surveyList: surveyList
            };
        }
        case ON_ALL_SURVEY_SELECT: {
            const selectAll = state.selectedSurveys < state.surveyList.length;
            let selectedSurveys = 0;
            let surveyList = [];
            if (selectAll) {
                surveyList = state.allSurvey.map((survey) => survey ? {
                    ...survey,
                    selected: true
                } : survey);
                selectedSurveys = surveyList.length;
            } else {
                surveyList = state.allSurvey.map((survey) => survey ? {
                    ...survey,
                    selected: true
                } : survey);
                selectedSurveys = 0;
            }
            return {
                ...state,
                selectedSurveys: selectedSurveys,
                allSurvey: surveyList,
                surveyList: surveyList
            };
        }
        case UPDATE_SEARCH_SURVEY: {
            return { ...state, searchSurvey: action.payload };
        }
        case HANDLE_SURVEY_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_SURVEY_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_SURVEY_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_SURVEY_LOADER: {
            return { ...state, loader: false };
        }
        case ON_SURVEY_QUESTIONS: {
            return { ...state, loader: false, selectedSurvey: action.payload };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/Survey.js